import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './HarddriveMonitorEditor.html?raw';
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import { DiskMonitor } from "./ServermonitorTypes";
import lang from 'dojo/_base/lang';
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';

class HarddriveMonitorEditor extends compose(_StatefulSection, _uiFrameMixin) {
    templateString: any = template;

    inputDiskCapacity: MdsLax<InstanceType<typeof NumberInput>>;
    inputFreeDiskSpace: MdsLax<InstanceType<typeof NumberInput>>;
    inputFreeSpaceAlertValue: MdsLax<InstanceType<typeof NumberInput>>;

    setup(entity: DiskMonitor) {
        this.show("dlg", entity.$Displayname);
        this.createDefaultButton("ok", lang.hitch(this, this._onClickConfirm));
        this.setStartupState("loading");
        let clonedEntity = lang.clone(entity);
        this.setData(clonedEntity);
    }

    private _onClickConfirm() {
        let currentData = this.getCurrentData();
        this.emit("confirmed", currentData);
        this.close();
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.inputDiskCapacity.setUnit("MB");
        this.inputFreeDiskSpace.setUnit("MB");
        this.inputFreeSpaceAlertValue.setUnit("MB");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(HarddriveMonitorEditor);